import { Component, Input, OnInit} from '@angular/core';
import { IboxtoolsItem } from 'app/models/iboxtools-item';
import { ConfigDataService } from '../../../services/config-data.service';
import { PersonalService } from '../../../services/personal.service';
import { SubSedeService } from '../../../services/subSede.service';
import { SubGrupoService } from '../../../services/subGrupo.service';
import { UnidadesOrganizativaService } from '../../../services/unidadesOrganizativa.service';
import { CentroCostoService } from '../../../services/centroCosto.service';
import { DatosOrganizativosService } from '../../../services/datosOrganizativos.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacionComponent } from '../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../components/shared/dialog-procesando/dialog-procesando.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import {MessageService} from 'primeng/api';
import {MyValidations} from '../../../utils/my-validations';
import { GruposLiquidacionService } from '../../../services/gruposLiquidacion.service';
import { ErroresService } from '../../../core/services/errores.service';
import { MomentSetService } from '../../../core/services/moment-set.service';
import { DatosOrganizativos } from 'app/models/datos-organizativos';

@Component({
  selector: 'app-datos-organizativos',
  templateUrl: './datos-organizativos.component.html',
  providers: [MessageService],
  styleUrls: ['./datos-organizativos.component.css']
})

export class DatosOrganizativosComponent implements OnInit {
  
  //Datos de entrada
  @Input() legajo;  
  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;

  //Datos especificos
  datosOrganizativosList: any;
  datoOrganizativo: any;
  form: FormGroup;

  //Combos
  sociedadesList: any;  
  sedesList: any;  
  subSedesList: any;
  posicionesList: any;
  centrosCostosList: any;
  unidadesOrganizativasList: any;
  gruposLiquidacionList: any;
  gruposList: any;
  subGruposList: any;

  //Datos comunes
  MensajeError: string;
  disabledEditing:boolean=true;
  eliminando: boolean;
  eliminacionInvalida: boolean;
  datosInvalida: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  submitted = false;
  
  //Control ibox
  toolboxList: any;
  toolboxEnabled:boolean=false;
  onlyNew: boolean = true;
  cortarRegistro: boolean = false;

  public cargaCompleta: boolean = false;
  
  constructor(private configDataSrv: ConfigDataService,
              private personalSrv: PersonalService,
              private subSedeSrv: SubSedeService,
              private subGupoSrv: SubGrupoService,
              private unidadesOSrv: UnidadesOrganizativaService,
              private centrosCostoSrv: CentroCostoService,
              private dialog: MatDialog,
              private snackBar: MatSnackBar,
              private datosOrganizativosSrv: DatosOrganizativosService,
              private erroresService: ErroresService,
              private formBuilder: FormBuilder,
              private gruposLiquidacionService: GruposLiquidacionService,
              private momentService: MomentSetService) {

              }

  get f() { return this.form?.controls; }

  ngOnInit(): void {    
    //desactivo formulario
    //this.habilitarForm(this.disabledEditing);
    
    //Lleno las listas para los combos
    this.configDataSrv.GetCombosInfoDatosOrganizativos()
      .subscribe(
        data => {
          this.sociedadesList=data["Sociedades"];
          this.sedesList=data["Sedes"];
          this.posicionesList=data["Posiciones"];
          this.gruposLiquidacionList=data["GruposLiquidacion"];
          this.gruposList=data["Grupos"];
        },
        error => {
          console.log(error);
        });
    
    this.configurarValidadores();
    this.obtenerActual();
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Datos Organizativos")) this.permisoEdicion = true;
  }

  configurarValidadores(){
    this.form = this.formBuilder.group({
      id: ['',Validators.required],
      personal: ['',Validators.required],
      desde: ['',Validators.required],
      hasta: ['',[Validators.required, MyValidations.fecHastaMenor]],
      sociedad: ['',Validators.required],
      sede: ['', Validators.required],
      subSede: ['', Validators.required],
      posicion: ['',Validators.required],
      unidadOrganizativa: ['', Validators.required],
      grupoLiquidacion: ['', Validators.required],
      grupoPersonal: ['', Validators.required],
      subGrupoPersonal: ['', Validators.required],
      centroCosto: [''],
    });
  }

  // ngOnChanges(changes: SimpleChanges)
  // {
  //   if(changes.personalId.currentValue){
  //      this.obtenerHistorial();
  //   }
  // }

  setearForm(d: any){
      this.datoOrganizativo = d;
      this.form.controls['id'].setValue(this.datoOrganizativo?.id);
      this.form.controls['personal'].setValue(this.datoOrganizativo?.personal);
      this.form.controls['sede'].setValue(this.datoOrganizativo?.sede);
      this.form.controls['sociedad'].setValue(this.datoOrganizativo?.sociedad);
      this.form.controls['desde'].setValue(new Date(this.datoOrganizativo?.desde));
      this.form.controls['hasta'].setValue(new Date(this.datoOrganizativo?.hasta));      
      this.form.controls['subSede'].setValue(this.datoOrganizativo?.subSede);
      this.form.controls['posicion'].setValue(this.datoOrganizativo?.posicion);
      this.form.controls['unidadOrganizativa'].setValue(this.datoOrganizativo?.unidadOrganizativa);
      this.form.controls['grupoLiquidacion'].setValue(this.datoOrganizativo?.grupoLiquidacion);
      this.form.controls['grupoPersonal'].setValue(this.datoOrganizativo?.grupoPersonal);
      this.form.controls['subGrupoPersonal'].setValue(this.datoOrganizativo?.subGrupoPersonal);
      this.form.controls['centroCosto'].setValue(this.datoOrganizativo?.centroCosto);

      this.cargarSubSedes(this.datoOrganizativo.sede);
      this.cargarSubGrupos(this.datoOrganizativo.grupoPersonal);
      this.cargarUnidadesOrganizativas(this.datoOrganizativo.sociedad);
      this.cargarCentrosCostos(this.datoOrganizativo.sociedad);

      if (this.datoOrganizativo != null && this.datoOrganizativo.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if(habilitado){
        this.form.controls['desde'].enable();
        this.form.controls['hasta'].enable();
        this.form.controls['sociedad'].enable();
        this.form.controls['sede'].enable();
        this.form.controls['subSede'].enable();
        this.form.controls['posicion'].enable();
        this.form.controls['unidadOrganizativa'].enable();
        this.form.controls['grupoLiquidacion'].enable();
        this.form.controls['grupoPersonal'].enable();
        this.form.controls['subGrupoPersonal'].enable();
        this.form.controls['centroCosto'].enable();
      }else{
        this.form.controls['desde'].disable();
        this.form.controls['hasta'].disable();
        this.form.controls['sociedad'].disable();
        this.form.controls['sede'].disable();
        this.form.controls['subSede'].disable();
        this.form.controls['posicion'].disable();
        this.form.controls['unidadOrganizativa'].disable();
        this.form.controls['grupoLiquidacion'].disable();
        this.form.controls['grupoPersonal'].disable();
        this.form.controls['subGrupoPersonal'].disable();
        this.form.controls['centroCosto'].disable();
      }
    }
  }

  cargarSubSedes(sede:number){
    if (sede != null) {
      this.subSedeSrv.getSubSedes(sede).subscribe(subSede => { this.subSedesList = subSede })
    }
  }

  cargarSubGrupos(grupo:number){
    if (grupo != null) {
      this.subGupoSrv.getSubGrupos(grupo).subscribe(subGrupo => { this.subGruposList = subGrupo })
    }
  }

  cargarUnidadesOrganizativas(sociedad:number){
    if (sociedad != null) {
      this.unidadesOSrv.getBySociedad(sociedad).subscribe(unidad => { this.unidadesOrganizativasList = unidad })
    }
  }

  cargarCentrosCostos(sociedad:number){
    if (sociedad != null) {
      this.centrosCostoSrv.getBySociedad(sociedad).subscribe(centro => { this.centrosCostosList = centro })
    }
  }

  onChangeSede(event) {
    this.form.controls['subSede'].setValue(null);
    this.cargarSubSedes(event.value);    
  }

  onChangeGrupo(event) {
    this.form.controls['subGrupoPersonal'].setValue(null);
    this.cargarSubGrupos(event.value);    
  }

  onChangeSociedad(event) {
    this.form.controls['unidadOrganizativa'].setValue(null);
    this.form.controls['centroCosto'].setValue(null);
    this.cargarUnidadesOrganizativas(event.value);    
    this.cargarCentrosCostos(event.value);    
  }

  save(event: Event){
    console.log(this.form.value);
  }

  CancelChange(e: boolean)
  {
    if (this.datosOrganizativosList != undefined)
    {
      if (this.datoOrganizativo.id == 0 && this.datosOrganizativosList.length == 0)
      {
        this.datoOrganizativo = null;
      }
      else if (this.datoOrganizativo.id == 0 && this.datosOrganizativosList.length > 0)
      {
        this.datoOrganizativo = this.datosOrganizativosList[0];
      }
    }
    else
    {
      this.datoOrganizativo = null;
    }

    this.setearForm(this.datoOrganizativo);
    this.deshabilitarEdicion();
  }

  async DeleteChange(e: boolean)
  {
    if (await this.validarEdicion(this.datoOrganizativo))
    {
      this.disabledEditing = true;
      this.habilitarForm(false);
      
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Esta seguro que desea eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          this.eliminando = true;

          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";
          
          this.eliminando = true;
          this.datosOrganizativosSrv.delete(this.datoOrganizativo.id).subscribe(
            response =>
            {
              this.snackBar.open("Se eliminó correctamente.", "OK", { duration: 10000 });

              this.eliminando = false;

              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              }); 

              this.obtenerActual();
            },
            error =>
            {
              this.eliminacionInvalida = true;
              this.eliminando = false;
              this.snackBar.open("No se pudo eliminar.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              }); 
            });
        }
      });
    }
  }

  async NewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      //Crear Nuevo
      let fdesde = new Date();
      let fecha = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
      if (fecha != undefined){
        fdesde = new Date(fecha.desde)
      }
      this.habilitarEdicion();
      this.form.controls['id'].setValue(0);
      this.form.controls['personal'].setValue(this.personalId);
      this.form.controls['desde'].setValue(fdesde);
      this.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }
  
  async CutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();
      
      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['hasta'].disable();
      });
    }
  }

  PeriodChange(index: number){  
    let datoOrganizativo = this.datosOrganizativosList.find(d => d.id == index);
    this.datoOrganizativo = datoOrganizativo;
    this.setearForm(this.datoOrganizativo);
    this.MensajeError = "";
  }

  async EditChange(e: boolean)
  {
    if (await this.validarEdicion(this.datoOrganizativo))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['desde'].disable();
        $this.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarForm(false);
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarForm(true);
  }

  SaveChange(e: boolean) {
    if (this.validarDatos())
    {
      console.log(this.form.value);
      if (this.form.valid)
      {
        let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
          width: '400px'
        });
        dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";
        
        if (this.form.value.posicion == null){
          let a=1;
        }

        let formulario = this.form.getRawValue();

        let datosOr: DatosOrganizativos = {
          id: formulario.id,
          personal: formulario.personal,
          desde: this.momentService.saveDateServer(formulario.desde, false),
          hasta: this.momentService.saveDateServer(formulario.hasta, false),
          sede: formulario.sede,
          subSede: formulario.subSede,
          sociedad: formulario.sociedad,
          posicion: formulario.posicion,
          unidadOrganizativa: formulario.unidadOrganizativa,
          grupoLiquidacion: formulario.grupoLiquidacion,
          grupoPersonal: formulario.grupoPersonal,
          subGrupoPersonal:formulario.subGrupoPersonal,
          centroCosto: formulario.centroCosto
        };

        this.datosOrganizativosSrv.save(datosOr, this.cortarRegistro).subscribe(
          data => {
            data.desde = this.momentService.convertDateServer(data.desde);
            data.hasta = this.momentService.convertDateServer(data.hasta);

            setTimeout(function ()
            {
              dialogProcesandoRef.close();
            });

            this.snackBar.open("Dato Organizativo guardado", "OK", { duration: 10000 });
            console.log(data);

            this.deshabilitarEdicion();
            this.obtenerHistorial();
            this.setearForm(data);
          },
          error =>
          {
            dialogProcesandoRef.close();
            if (error.status == 400)
            {
              this.datosInvalida = true;
              
              this.MensajeError = this.erroresService.MostrarError400(error);
            }
            else
            {
              this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
            }
          }); 
      }
    }
  }

  private obtenerHistorial()
  {    
    this.datosOrganizativosSrv.getByPersonalId(this.personalId).subscribe(
      data => 
      {
        data.data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.toolboxList = [];

        if (data.code == 200)
        {
          data.data.forEach(d =>
          {
            let item = new IboxtoolsItem(d);
            this.toolboxList.push(item);
          });

          this.datosOrganizativosList = data.data;
        }
        else
        {
          this.setearForm(null);
          this.datoOrganizativo = null;
          this.datosOrganizativosList = [];
        }
      },
      error => 
      {
        console.log(error);
      });
      
      this.onlyNew = false;
      this.toolboxEnabled=true;
  }

  private obtenerActual()
  {
    let fechaHoy = new Date();
    this.datosOrganizativosSrv.getByPersonalId(this.personalId).subscribe(
      datoO =>
      {
        datoO.data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        if (datoO.data.length > 0)
        {
          this.datoOrganizativo = datoO.data.find(f=> Date.parse(f.desde) <= fechaHoy.getTime() &&
                                                      Date.parse(f.hasta) >= fechaHoy.getTime());
          
          if (this.datoOrganizativo == null) this.datoOrganizativo = datoO.data[0];
          this.obtenerHistorial();
        }
        else
        {
          this.datoOrganizativo = null;
        }
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        console.log(error);
      });
  }

  validarDatos() : boolean
  {
    let desde = this.form.get("desde").value.toDateString();
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        this.form.get("desde").setErrors({'anteriorRetroactividad': true });
      }
    }
    
    if (this.form.valid)
    {
      return true;
    }
    else
    {
      this.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
}
